import * as React from 'react'

export type RemoveScrollProps = {
  children?: React.ReactNode
} & Record<string, unknown>

export const RemoveScroll: React.FC<RemoveScrollProps> = ({ children }) => {
  return React.createElement(React.Fragment, null, children)
}

export default RemoveScroll


